module.exports = __webpack_public_path__ + "static/media/circle-error.882388c1.svg";